<ion-header class="ion-no-border">
  <ion-toolbar color="dark">
    <ion-buttons slot="start">
      <ion-menu-button class="header-menu-button"></ion-menu-button>
    </ion-buttons>
    <ion-title>Manutenção</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="maintenance-settings">
  <!-- ============================================ -->
  <!-- HERO                                         -->
  <!-- ============================================ -->
  <section class="hero">
    <div class="hero__body">
      <div class="hero__status">
        <ion-icon name="construct-outline"></ion-icon>
        <span>CONFIGURAÇÕES</span>
      </div>
      <h1 class="hero__title">Manutenção</h1>
      <p class="hero__meta">
        @if (lastUpdatedAt(); as t) {
          Atualizado: {{ t | date: 'HH:mm:ss' }}
        } @else {
          Carregando...
        }
      </p>
    </div>

    <div class="hero__actions">
      <ion-button fill="clear" class="hero__btn" (click)="refresh()" [disabled]="loading()">
        <ion-icon slot="start" name="refresh-outline"></ion-icon>
        Atualizar
      </ion-button>
    </div>
  </section>

  <div class="container">
    <!-- ============================================ -->
    <!-- STATS GRID                                   -->
    <!-- ============================================ -->
    <section class="stats">
      <div class="stat-card">
        <div class="stat-card__head">
          <ion-icon name="construct-outline"></ion-icon>
          <span class="stat-card__name">TOTAL</span>
        </div>
        <div class="stat-card__value">{{ totalCount() }}</div>
        <div class="stat-card__label">Aplicativos</div>
      </div>

      <div class="stat-card" [class.stat-card--alert]="activeCount() > 0">
        <div class="stat-card__head">
          <ion-icon name="alert-circle-outline"></ion-icon>
          <span class="stat-card__name">EM MANUTENÇÃO</span>
        </div>
        <div class="stat-card__value">{{ activeCount() }}</div>
        <div class="stat-card__label">
          @if (activeCount() > 0) {
            Usuários bloqueados
          } @else {
            Nenhum ativo
          }
        </div>
      </div>

      <div class="stat-card stat-card--success">
        <div class="stat-card__head">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <span class="stat-card__name">DISPONÍVEIS</span>
        </div>
        <div class="stat-card__value">{{ availableCount() }}</div>
        <div class="stat-card__label">Em operação</div>
      </div>
    </section>

    <!-- ============================================ -->
    <!-- MAINTENANCE CARDS                            -->
    <!-- ============================================ -->
    <section class="cards-grid">
      @for (type of maintenanceTypes(); track type.key) {
        <article class="maint-card" [class.maint-card--active]="type.status().active">
          <!-- HEAD -->
          <header class="maint-card__head">
            <div class="maint-card__icon">
              <ion-icon [name]="type.icon"></ion-icon>
            </div>
            <div class="maint-card__title-block">
              <h3 class="maint-card__title">{{ type.name }}</h3>
              <p class="maint-card__desc">{{ type.description }}</p>
            </div>
            <div class="maint-card__badge" [class.maint-card__badge--on]="type.status().active">
              <span class="maint-card__dot"></span>
              {{ type.status().active ? 'ATIVO' : 'INATIVO' }}
            </div>
          </header>

          <!-- ALERT BANNER -->
          @if (type.status().active && type.status().expiresAt) {
            <div class="maint-card__alert">
              <ion-icon name="time-outline"></ion-icon>
              <div class="maint-card__alert-body">
                <span class="maint-card__alert-label">Expira em</span>
                <span class="maint-card__alert-value">
                  {{ type.status().expiresAt | date: 'dd/MM/yyyy HH:mm' }}
                </span>
              </div>
            </div>
          }

          <!-- TOGGLE -->
          <div class="maint-card__toggle">
            <div class="maint-card__toggle-info">
              <span class="maint-card__toggle-title">Manutenção ativa</span>
              <span class="maint-card__toggle-hint">Bloqueia acesso dos usuários ao app</span>
            </div>
            <ion-toggle
              [checked]="type.status().active"
              (ionChange)="updateActive(type, $any($event).detail.checked)"></ion-toggle>
          </div>

          <!-- MESSAGE -->
          <div class="maint-card__field">
            <label class="maint-card__label">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
              Mensagem exibida aos usuários
            </label>
            <textarea
              class="maint-card__input"
              rows="2"
              [value]="type.status().message"
              (input)="updateMessage(type, $any($event).target.value)"
              placeholder="Digite a mensagem"></textarea>
          </div>

          <!-- TIME (apenas canais com expiração; PAYMENT é toggle manual) -->
          @if (type.hasExpiry) {
            <div class="maint-card__field">
              <label class="maint-card__label">
                <ion-icon name="time-outline"></ion-icon>
                Duração (HH:MM)
              </label>
              <input
                class="maint-card__input maint-card__input--time"
                type="time"
                [value]="type.status().time"
                (input)="updateTime(type, $any($event).target.value)" />
            </div>
          }

          <!-- ACTIONS -->
          <div class="maint-card__actions">
            <ion-button
              expand="block"
              class="maint-card__save"
              [class.maint-card__save--modified]="isModified(type.key)"
              [disabled]="!isModified(type.key) || savingKey() === type.key"
              (click)="saveChanges(type.key, type.status())">
              @if (savingKey() === type.key) {
                <ion-spinner slot="start" name="crescent"></ion-spinner>
                Salvando...
              } @else {
                <ion-icon slot="start" name="save-outline"></ion-icon>
                @if (isModified(type.key)) {
                  Salvar alterações
                } @else {
                  Salvo
                }
              }
            </ion-button>
          </div>
        </article>
      }
    </section>
  </div>
</ion-content>
